var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonusPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3.6,
    fill: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96249 7.65V6.6375C5.96249 4.9711 7.31249 3.6 8.99999 3.6C10.6664 3.6 12.0375 4.9711 12.0375 6.6375V7.65H12.375C13.1133 7.65 13.725 8.26172 13.725 9V13.05C13.725 13.8094 13.1133 14.4 12.375 14.4H5.62499C4.86562 14.4 4.27499 13.8094 4.27499 13.05V9C4.27499 8.26172 4.86562 7.65 5.62499 7.65H5.96249ZM7.31249 7.65H10.6875V6.6375C10.6875 5.70938 9.92812 4.95 8.99999 4.95C8.05078 4.95 7.31249 5.70938 7.31249 6.6375V7.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusPadlock);
export default __webpack_public_path__ + "static/media/bonus-padlock.ea63ce50139cb2af2f6a550483e108a6.svg";
export { ForwardRef as ReactComponent };